import React from 'react';
import Text from 'components/react-styled-core/Text';

const PageTitle = ({ children }) => (
    <Text
        fontFamily="heading"
        fontSize="4xl" // 32px
        lineHeight="4xl"
        pt="5x" // 20px
        pb="3x" // 12px
    >
        {children}
    </Text>
);

export default PageTitle;
